import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormSyncErrors, getFormAsyncErrors, getFormSubmitErrors } from 'redux-form';
import { Form, Alert, Button, Spinner, Col } from 'react-bootstrap';
import { renderField } from '../../common/FormsControls.jsx';
import { projectName } from '../../../../config';
import { phoneFormat, required, slug } from '../../../../_utils/validators';

import LivingPlaceAutocomplete from '../../common/LivingPlaceAutocomplete.jsx';
import ProfileErrors from './ProfileErrors.jsx';

import asyncSlugValidate from './asyncValidate';
import normalizePhone from './normalizePhone';
import { FORM_FIELDS } from './formFields';


const ProfileFormSecond = (props) => {
  let errors = {...props.errors, ...props.aErrors, ...props.sErrors}

  let elementsRef = [];
  const excludeFields = ['lang', 'payment_service'];
  for (let key of Object.keys(FORM_FIELDS)) {
    if (!excludeFields.includes(key)){
      elementsRef[key + '_Ref'] = useRef(null);
    }
  }

  const handleErrorClick = (e, fieldName) => {
    e.preventDefault();
    elementsRef[fieldName + '_Ref'].current.focus();
  }

  return(
    <Form onSubmit={ props.handleSubmit } className={ 'cabinet-form ' + (props.anyTouched ? ' was-validate' : '') }>

      <Field label={ gettext('Номер телефона') }
             placeholder={ gettext('+1 333 555 77 99') }
             helptext={ gettext('Не обязательно. Может быть использован для восстановления доступа и получения персональных предложений. Нигде не выводится на сайте и не передается третьим лицам.') }
             component={ renderField }
             // validate={ [phoneFormat] }
             normalize={ normalizePhone }
             format={ normalizePhone }
             onBlur={ props.setLocalStorage }
             inputRef={ elementsRef['phone_number_Ref'] }
             name='phone_number'/>

      <LivingPlaceAutocomplete label={ gettext('Место жительства') }
                               helptext={ gettext('Укажите место вашего проживания (город/населенный пункт).') }
                               autoFocus={ false }
                               simple={ false }
                               onBlur={ props.setLocalStorage }
                               inputRef={ elementsRef['live_place_Ref'] }/>

      <Field label={ gettext('Расскажите о себе') }
             helptext={ gettext('Ваш гитарный путь, направления, достижения, опыт и т.д.') }
             component={ renderField }
             onBlur={ props.setLocalStorage }
             inputRef={ elementsRef['about_Ref'] }
             element='auto_textarea'
             name='about'/>

      <Form.Row>
        <Col sm={ 12 } md={ 6 }>
          <Field label={ gettext('Предпочитаемый язык') }
                 helptext={ gettext('Выберите язык, на котором вы хотите получать сообщения.') }
                 component={ renderField }
                 onBlur={ props.setLocalStorage }
                 element='select'
                 name='lang'>
              { props.langList.map(s => <option value={ s.value }>{ s.label }</option>) }
          </Field>
        </Col>
        <Col sm={ 12 } md={ 6 }>
          <Field label={ gettext('Платежный сервис') }
                 helptext={ gettext('Укажите, какую платежную систему использовать для покупок по умолчанию.') }
                 component={ renderField }
                 onBlur={ props.setLocalStorage }
                 element='select'
                 name='payment_service'>
              { props.paymentSystems.map(s => <option value={ s.value }>{ s.label }</option>) }
          </Field>
        </Col>
      </Form.Row>

      <Field label={ gettext('Адрес вашей страницы') }
             placeholder={ gettext('Адрес вашей страницы') }
             helptext={ gettext('Адрес страницы может содержать латинские буквы, цифры, ".", "_" и "-". Ваша личная страница будет иметь такое имя и станет доступна по ссылке') +
             ' ' + `https://${projectName}/` + gettext('Адрес страницы') + '/'}
             required={ true }
             component={ renderField }
             validate={ [required, slug] }
             onBlur={ props.setLocalStorage }
             inputRef={ elementsRef['slug_Ref'] }
             name='slug'/>

      { props.invalid &&
        <Alert variant='danger' className='mt-3'>
          { gettext('Проверьте правильность заполнения формы.') }
          <ProfileErrors errors={ errors } onErrorClick={ handleErrorClick }/>
        </Alert>
      }

      <div className='text-lg-right mt-3'>
        <Button variant="orange" type="submit" disabled={ props.submitting || props.invalid }
                className='mt-2 mt-md-0'>
          { props.submitting
            ? <>
                <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" className='mr-1'/>
                { gettext('Сохраняется') + '...' }
              </>
            : gettext('Сохранить') }
        </Button>
      </div>
    </Form>);
}

ProfileFormSecond.PropTypes = {
  langList: PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired
  }),
  paymentSystems: PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired
  }),
  initialValues: PropTypes.shape({
    phone_number: PropTypes.string,
    living_place: PropTypes.string,
    about: PropTypes.string,
    lang: PropTypes.number,
    payment_service: PropTypes.string,
    slug: PropTypes.string,
  }),
  handleSubmit: PropTypes.func.isRequired,
  anyTouched: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,
  errors: PropTypes.object,
  aErrors: PropTypes.object,
  sErrors: PropTypes.object,
  fields: PropTypes.object,
}

let mapStateToProps = (state) => {
  return {
    errors: getFormSyncErrors('profileFormSecond')(state),
    aErrors: getFormAsyncErrors('profileFormSecond')(state),
    sErrors: getFormSubmitErrors('profileFormSecond')(state),
  }
};

export default compose(
  connect(mapStateToProps, {}),
  reduxForm({
    form:'profileFormSecond',
    enableReinitialize: true,
    asyncValidate: asyncSlugValidate,
    asyncBlurFields: ['slug'],
  }),
)(ProfileFormSecond);

